import React from 'react'
import TeacherManagement from '../../Components/AdminComponents/TeacherManagement\'/TeacherManagement'
import AdminDash from '../../Components/AdminComponents/AdminDash/AdminDash'

function TeacherManagePage() {
  return (
   <AdminDash>
      <TeacherManagement/>
   </AdminDash>
  )
}

export default TeacherManagePage